<template>
    <div class="global-admin-dashboard-view">
        <h1>Global Admin Dashboard</h1>
        <p>Welcome to the Global Admin Dashboard!</p>

        <div class="global-dashboard-line" style="gap: 10px">
            <hidden-table :table="{headers: ['Maschine', 'Weather Module'], rows: weatherMaschines}">
                <template #header>
                    <h3>Weather Module</h3>
                    <h2>{{ weatherMaschinesNumber }} / {{ totalMaschines }}</h2>
                    <p>
                        Maschinen von den Wetterdaten erhoben werden.
                    </p>
                </template>

              

            </hidden-table>

            <hidden-table :table="{headers: ['Maschine', 'Erstell Datum'], rows: maschineCreatedDate}">
                <template #header>
                    <h3>Neue Maschinen</h3>
                    
                    <h2>{{creationFilteredMaschines.length }}</h2>
                    <p>Maschinen wurden in einem Zeitraum der</p>
                    <div>
                        <md-field>
                            <label for="">Erstellt</label>
                            <md-select v-model="creationFilter">
                                <md-option value="7">letzten 7 Tagen</md-option>
                                <md-option value="30">letzten 30 Tagen</md-option>
                                <md-option value="90">letzten 90 Tagen</md-option>
                                <md-option value="180">letzten 180 Tagen</md-option>
                                <md-option value="365">letzten 365 Tagen</md-option>
                                <md-option value="-1">keine Begrenzung</md-option>

                            </md-select>
                        </md-field>
                    </div>

                </template>

                
            </hidden-table>

        </div>
        <div class="global-dashboard-line" style="gap: 10px">
            <hidden-table :table="{headers: ['Maschine', 'Offline Date'], rows: offlineMaschines}">
                <template #header>
                    <h3>Offline Maschinen</h3>
                    <h2>{{ offlineMaschinesLength }} / {{ totalMaschines }}</h2>
                    <p>
                        Maschinen die keine Verbindung zum Cloud Service haben.
                    </p>
                </template>

               
            </hidden-table>
        </div>
    </div>
</template>

<script>
import hiddenTable from '@/components/dashboard-components/hidden-table.vue';
import moment from 'moment';
import { mapState } from 'vuex';
export default {
    name: "GlobalAdminDashboardView",
    components: {
        'hidden-table':hiddenTable
    },
    computed:{
        ...mapState(['globalView']),

        totalMaschines(){
            return this.globalView.maschinesAdminDashboard.length
        },
        weatherMaschinesNumber(){
            return this.globalView.maschinesAdminDashboard.filter(e => e.weatherModule).length
        },
        weatherMaschines(){
            return this.globalView.maschinesAdminDashboard.map(e => [e.text, e.weatherModule] )
        },

        creationFilterDate(){
            const now = moment()
            return now.subtract(this.creationFilter, 'days')
        },
        creationFilteredMaschines(){
            if(this.creationFilter == -1)
                return this.globalView.maschinesAdminDashboard

            return this.globalView.maschinesAdminDashboard.filter(e => moment(e.createdDate).isAfter(this.creationFilterDate))
        },

        maschineCreatedDate(){
            return this.creationFilteredMaschines.map(e => [e.text, e.createdDate] )
            
        },
        offlineMaschinesLength(){
            return this.globalView.offlineMaschines.length
        },
        offlineMaschines(){
            return this.globalView.offlineMaschines.map(e => [e.name, e.offlineDate] )
        },  
    },

    data(){
        return{
            creationFilter: '7',
        }
    }
};
</script>

<style scoped>
.global-admin-dashboard-view {
    text-align: center;
    padding: 10px;

    display: flex;
    flex-direction: column;
    gap: 10px;
}

.global-admin-dashboard-view .global-dashboard-line{
    display: flex;
    flex-direction: row;
    /*justify-content: center;
    align-items: stretch;*/
}
@media screen and (max-device-width: 800px) {/*für mobil*/
    .global-admin-dashboard-view .global-dashboard-line{
        flex-direction: column;
    }
    
}
</style>